import { ACTIVATE_AGENT_STAFF_URL, ADD_AGENT_STAFF_URL, AGENT_STAFF_LIST_URL, APPROVE_AGENT_STAFF_URL, DEACTIVATE_AGENT_STAFF_URL, EDIT_AGENT_STAFF_URL, REJECT_AGENT_STAFF_URL, RESET_AGENT_PASSWORD_URL, UNBLOCK_AGENT_URL, VIEW_AGENT_STAFF_URL } from "../../constant"
import { multipartRequest, resourceRequest } from "../calls"


/* -------- AGENTS ---------- */
export function doFetchAgentStaff(token, data) {
    return resourceRequest(token, AGENT_STAFF_LIST_URL, data)
}

export function doAddAgentStaff(token, data) {
    return resourceRequest(token, ADD_AGENT_STAFF_URL, data)
}

export function doViewAgentStaff(token, data) {
    return resourceRequest(token, VIEW_AGENT_STAFF_URL, data)
}

export function doEditAgentStaff(token, data) {
    return resourceRequest(token, EDIT_AGENT_STAFF_URL, data)
}

export function doActivateAgentStaff(token, data) {
    return resourceRequest(token, ACTIVATE_AGENT_STAFF_URL, data)
}

export function doDeactivateAgentStaff(token, data) {
    return resourceRequest(token, DEACTIVATE_AGENT_STAFF_URL, data)
}

export function doApproveAgentStaff(token, data) {
    return resourceRequest(token, APPROVE_AGENT_STAFF_URL, data)
}

export function doRejectAgentStaff(token, data) {
    return resourceRequest(token, REJECT_AGENT_STAFF_URL, data)
}

export function doResetAgentPassword(token, data) {
    return resourceRequest(token, RESET_AGENT_PASSWORD_URL, data)
}

export function doUnblockAgent(token, data) {
    return resourceRequest(token, UNBLOCK_AGENT_URL, data)
}



